import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { Document, Page, pdfjs  } from 'react-pdf'

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //'pdfjs-dist/build/pdf.worker.min.mjs',
  'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.4.168/legacy/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

//console.log(pdfjs.GlobalWorkerOptions.workerSrc);

function DocButtons({numPages, pageNumber, previousPage, nextPage}) {

  let multiple_pages = false;

  if (numPages > 1) {
    multiple_pages = true;
  }

  let leftDisabled = pageNumber <= 1;
  let rightDisabled = pageNumber >= numPages;

  return multiple_pages ? (
    <div className="btn-toolbar justify-content-between">
      <div className='mx-auto btn-group'>
        <button
          type="button"
          className={(leftDisabled ? "lk-svg-button-disabled" : "lk-svg-button") + " mx-2"}
          disabled={leftDisabled}
          onClick={previousPage}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="36" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16">
            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
          </svg>
        </button>
        <div className="my-auto">
          Страница {pageNumber || (numPages ? 1 : '--')} из {numPages || '--'}
        </div>
        <button
          type="button"
          className={(rightDisabled ? "lk-svg-button-disabled" : "lk-svg-button") + " mx-2"}
          disabled={rightDisabled}
          onClick={nextPage}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="36" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
        </button>
      </div>
    </div>
  ) : (
    <></>
  );
}


function ShowDoc({orderFormPdf}) {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const media_url = useContext(MEDIA_URL);

  let file = media_url + orderFormPdf;

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  return (
  
    <>
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page 
          pageNumber={pageNumber}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          width={Math.min(window.screen.width * 0.56, 1200)} 
        />
      </Document>
      <DocButtons
        numPages={numPages}
        pageNumber={pageNumber}
        previousPage={previousPage}
        nextPage={nextPage}
      />
      
    </>
  ); 
}

const handlePrint = async (pdf_document) => {

  let iframe_with_pdf = document.createElement('iframe');
  iframe_with_pdf.style.display = 'none';
  iframe_with_pdf.src = pdf_document;
  document.body.appendChild(iframe_with_pdf);

  iframe_with_pdf.onload = () => {
    setTimeout(() => {
      iframe_with_pdf.focus();
      iframe_with_pdf.contentWindow.print();
    });
 };
}


export default function ViewDocumentModal ({modalId, headerText, document, draft=false}) {

  return(
    <div className="modal fade modal-xl" id={modalId} tabIndex="-1" aria-labelledby={modalId + "Label"} aria-hidden="true">
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h2 className="modal-title fs-5" id={modalId + "Label"}>{headerText}</h2>
            <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          {draft && 
            <div className="text-center align-middle modal-message">
              <span>Вы можете изменить учетные данные организации и сгенерировать договор повторно</span>
            </div>
          }
          <div className="modal-body">
            <ShowDoc
              orderFormPdf={document}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="mx-2 btn lk-button" onClick={(e) => handlePrint(document)}>Печать</button>
            <button type="button" className="btn btn-secondary lk-bootstrap-button" data-bs-dismiss="modal">Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  )
}
  